var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"show-disabled-button":true,"status":"warning"}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__(
          "mrWidget|Merge blocked: pipeline must succeed. It's waiting for a manual action to continue."
        ))+"\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }